import { createContext } from 'react';
import type { WorkflowListItem } from '../../types/workflow';

export interface WorkflowPanelContextValue {
  workflows: WorkflowListItem[];
  isLoading: boolean;
  /** GET /workflows failed (after retries) — the list shows a retry affordance, not "All caught up". */
  isError: boolean;
  /** A fetch is in flight (initial or a manual retry) — drives the retry button's in-flight state. */
  isFetching: boolean;
  /** Re-run the workflows query (used by the error-state retry button). */
  refetch: () => void;
  dismiss: (id: string) => Promise<void>;
  restore: (id: string) => Promise<void>;
  openModal: (key: string, params: Record<string, string>) => void;
  closeModal: () => void;
  /**
   * Monotonically-increasing signal. The rail and the mobile sheet each own their
   * open-state locally (they are both always mounted, only CSS-hidden per breakpoint),
   * so a deeply-nested CTA cannot flip them directly. Instead it calls closePanel(),
   * which bumps this counter; whichever surface is open collapses via a subscribing effect.
   * Without this, a `navigate` action fired from the sheet/rail leaves the panel open on
   * top of the destination — the action appears to do nothing.
   */
  closeSignal: number;
  /** Request that the open workflow surface (rail or mobile sheet) collapse. */
  closePanel: () => void;
  /** Whether the desktop workflow rail is currently expanded. */
  isRailExpanded: boolean;
  /** Toggle the desktop workflow rail open/closed. */
  toggleRail: () => void;
}

export const WorkflowPanelContext = createContext<WorkflowPanelContextValue | null>(null);
